import {
  DesktopOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  GroupOutlined,
  SettingOutlined,
  UserOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Modal, Form, Input, Space, Button } from "antd";
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import axios from "axios";
const { Content, Sider } = Layout;

const items = [
  { key: "/logo", label: "LOGO" },
  { key: "/dashboard", icon: <DesktopOutlined />, label: "Dashboard" },
  { key: "/contracts", icon: <FolderOpenOutlined />, label: "Contracts" },
  { key: "/users", icon: <UsergroupAddOutlined />, label: "Users" },
  {
    key: "/contract_templates",
    icon: <FolderOutlined />,
    label: "Contract templates",
  },
  { key: "/business", icon: <GroupOutlined />, label: "Business partners" },
];
const MainLayout = ({ children }) => {
  const orgId = localStorage.getItem("orgId") || null;
  const userId = localStorage.getItem("userId") || null;
  const [isOrgModalOpen, setIsOrgModalOpen] = useState(false);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [orgData, setOrgData] = useState({});
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();
  const onClick = (e) => {
    if (e.key === "org") {
      setIsOrgModalOpen(true);
    } else if (e.key === "user") {
      setIsUserModalOpen(true);
    } else {
      navigate(e?.key);
    }
  };
  const closeModal = () => {
    setIsOrgModalOpen(false);
    setIsUserModalOpen(false);
  };
  const fetchData = async () => {
    try {
      const response = await axios.get(
        "/api/organizations/" + orgId
      );
      setOrgData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchUserData = async () => {
    try {
      const response = await axios.get("/api/users/" + userId);
      setUserData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [isOrgModalOpen]);
  useEffect(() => {
    fetchUserData();
  }, [isUserModalOpen]);
  return (
    <Layout style={{ height: "100vh" }}>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => {}}
        onCollapse={(collapsed, type) => {}}
      >
        <div className="demo-logo-vertical" />
        <Menu
          theme="dark"
          mode="inline"
          // defaultSelectedKeys={["/dashboard"]}
          // items={items}
          onClick={onClick}
        >
          <Menu.Item key="/dashboard" icon={<DesktopOutlined />}>
            Dashboard
          </Menu.Item>
          <Menu.Item key="/contracts" icon={<FolderOpenOutlined />}>
            Contracts
          </Menu.Item>
          <Menu.Item key="/users" icon={<UsergroupAddOutlined />}>
            Users
          </Menu.Item>
          <Menu.Item key="/contract_templates" icon={<FolderOutlined />}>
            Contract Templates
          </Menu.Item>
          <Menu.Item key="/business" icon={<GroupOutlined />}>
            Business Partners
          </Menu.Item>

          {/* Divider */}
          <Menu.Divider />
        </Menu>

        {/* Bottom Menu Items */}
        <Menu
          theme="dark"
          mode="inline"
          onClick={onClick}
          style={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            paddingBottom: "50px",
          }}
        >
          <Menu.Item key="org" icon={<SettingOutlined />}>
            Organization
          </Menu.Item>
          <Menu.Item key="user" icon={<UserOutlined />}>
            User
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout style={{ maxHeight: "calc(100vh - 48px)", overflowY: "auto" }}>
        <Content>
          <div>{children}</div>
        </Content>
      </Layout>
      <Footer />
      <Modal
        title="Organization details"
        open={isOrgModalOpen}
        onOk={closeModal}
        onCancel={closeModal}
      >
        <Form
          name="org_form"
          //onFinish={}
          style={{
            maxWidth: 600,
          }}
          layout="vertical"
          initialValues={{
            name: orgData.name,
            email: orgData.email,
            phone_number: orgData.phone_number,
            country: orgData.country,
            status: orgData.status,
          }}
        >
          <Form.Item name="name" label="Name">
            <Input />
          </Form.Item>

          <Form.Item name="email" label="Email">
            <Input />
          </Form.Item>
          <Form.Item name="phone_number" label="Phone number">
            <Input />
          </Form.Item>
          <Space>
            <Form.Item name="country" label="country">
              <Input />
            </Form.Item>
            <Form.Item name="status" label="status">
              <Input />
            </Form.Item>
          </Space>
        </Form>
      </Modal>
      <Modal
        title="User details"
        open={isUserModalOpen}
        onOk={closeModal}
        onCancel={closeModal}
        footer={[
          <Button onClick={closeModal}
          style={{ backgroundColor: "#1890ff", color: "#fff", border: "none", padding: "8px 16px", borderRadius: "4px", cursor: "pointer" }}>
            Reset Password
          </Button>
        ]}
      >
        <Form
          name="user_form"
          //onFinish={}
          style={{
            maxWidth: 600,
          }}
          layout="vertical"
          initialValues={{
            username: userData.username,
            role: userData.role,
            full_name: userData.full_name,
            // dob: userData.dob,
            full_name_ar: userData.full_name_ar,
            email: userData.email,
            mobile_number: userData.mobile_number,
            status: userData.status,
            country: userData.country,
          }}
        >
          <Form.Item name="username" label="Username">
            <Input disabled/>
          </Form.Item>

          <Form.Item name="role" label="role">
            <Input disabled/>
          </Form.Item>

          <Space>
            <Form.Item name="email" label="Email">
              <Input disabled />
            </Form.Item>

            <Form.Item name="mobile_number" label="Mobile number">
              <Input disabled/>
            </Form.Item>
          </Space>

          <Form.Item name="country" label="Country">
            <Input disabled/>
          </Form.Item>
        </Form>
      </Modal>
    </Layout>
  );
};
export default MainLayout;
